import React from 'react';
import '../style/Kyagu.scss';
// component
import Header from '../components/public/Header';
import PhotoGallery from '../components/thirdParty/PhotoGallery';
// React Bootstrap
import { Container, Row, Col, Image, Tab, Nav } from 'react-bootstrap';
// React redux
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
function Kyagu({ lang }) {
  const Images = [
    {
      // no 2
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fteropa.png?alt=media&token=c059dfb6-98d0-4dd5-aa1f-a23a40df0a0d',
      width: 3,
      height: 3,
    },
    {
      // no 3 
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FdorjeChang.png?alt=media&token=009dd271-d2c2-4a05-b051-5b134dc1b5fd',
      width: 4,
      height: 5,
    },
    {
      // no 4
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fnaropa.png?alt=media&token=bed107ec-9645-4af2-a65a-631ea102c4fe',
      width: 3,
      height: 3,
    },
  ];

  const tabList = [
    {
      id: 1,
      to: null,
      title: 'བཀའ་བརྒྱུད།'
    },
    {
      id: 2,
      to: '/',
      title: 'ཉེ་བརྒྱུད།'
    },
    {
      id: 3,
      to: null,
      title: 'དར་མ་དབང་ཕྱུག །'
    },
    {
      id: 4,
      to: null,
      title: 'ཏི་ཤྲཱི་རས་པ།'
    },
    {
      id: 5,
      to: null,
      title: 'རས་པ་དཀར་པོ།'
    },
    {
      id: 6,
      to: null,
      title: 'ལུས་མེད་རྡོ་རྗེ།'
    },
    {
      id: 7,
      to: null,
      title: 'བྱང་ཆུབ་གཞོན་ནུ།'
    },
    {
      id: 8,
      to: null,
      title: 'རས་པ་བློ་གྲོས་རྡོ་རྗེ།'
    },
    {
      id: 9,
      to: null,
      title: 'རས་པ་བརྩོན་འགྲོས་དཔལ།'
    },
    {
      id: 10,
      to: null,
      title: 'བླང་རས་པ་གྲགས་པ་རྒྱལ་མཚན།'
    },
    {
      id: 11,
      to: null,
      title: 'བསོད་ནམས་བཟང་པོ།'
    },
    {
      id: 12,
      to: null,
      title: 'ཌཱཀྐིའི་བདེ་སྐྱོང་བཟང་མོ།'
    },
    {
      id: 13,
      to: null,
      title: 'འབར་བའི་རྡོ་རྗེ།'
    },
    {
      id: 14,
      to: null,
      title: 'བཀའ་བརྒྱུད་བཀྲ་ཤིས།'
    },
    {
      id: 15,
      to: null,
      title: 'སྡེ་གསར་དབང་དགའ།'
    },
    {
      id: 16,
      to: null,
      title: 'བློ་གྲོས་རིན་ཆེན།'
    },
    {
      id: 17,
      to: '/',
      title: 'རིང་བརྒྱུད།'
    },


  ]
  return (
    <>
      <Header />
      <Container className='kyagu'>
        <div className='kyaguBody pt-4 pr-5 pl-5'>
          <Row className='kyaguContent d-flex align-items-center justify-content-center'>
            <Col className='align-items-center'>
              <PhotoGallery images={Images} />
            </Col>
          </Row>
          {
            lang === 'CH' ? (
              // chinese Section
              <>
                <Row>
                  <Col>
                    <h3 className='text-left text-secondary chinese mt-3 '>
                      傳承介紹
                </h3>
                    <p className='chineseParagraph'>
                      噶舉傳承第一位上師帝洛巴以口傳教法，一代一代連續無間斷地將噶舉傳承的法教完整地傳至巴融法王蔣揚洛卓仁欽。透過世世代代的傳承鏈，上師們將佛陀法教完整地保存及延續，這是證悟上師與全然虔信弟子之間的殊勝連結。巴融噶舉傳承殊勝之處，是上師弟子間以「口耳相傳，以心印心」的方式如一串黃金念珠一般，將殊勝秘密的禪修法教傳遞下去。為表示對傳承上師們極大的敬意，故稱為「黃金珠鬘」。閉關實修者在解脫法門依靠殊勝大手印，方便法門倚靠那若六法，而夢瑜伽則含攝那洛六法其中。巴融噶舉傳承源自釋迦牟尼佛，經由大瑜伽士馬爾巴
                      譯師將此無間斷的傳承由印度帶入西藏。他主要的兩位上
                      師是古印度那瀾陀佛學院最殊勝的的學者及大成就者那洛
                      巴和帝若巴。馬爾巴將傳承帶入西藏後傳授給他的弟子密
                      勒日巴。密勒日巴是西藏最著名及最有成就的密續瑜伽士
                      ，他在一生之中便獲得最高的證悟。崗波巴大師是密勒日
                      巴的弟子，在三部著名的經典裏，佛陀曾預言崗波巴的轉
                      世。崗波巴融合了密勒日巴大手印傳承及噶當巴道次第傳
                      承，此傳承被稱為達波噶舉。達瑪旺秋聽從空行母的授記
                      跟隨崗波巴大師學習，他是崗波巴最重要的弟子，曾不顧
                      生命救過崗波巴很多次，崗波巴把全部的教法全部傳授於
                      他，並獲得極高的證悟成就，並創建巴融寺，位於西藏拉
                      拓區北部，他被視為是巴融噶舉的創始者，後經過他的弟
                      子帝師瑞巴，瑞巴卡波、慮美多傑等一直傳至今日。
                </p>
                  </Col>
                </Row>
                {/* first intro */}
                <Row>
                  <Col>
                    <h3 className='text-left text-secondary chinese mb-3 '>
                      達瑪旺秋 1127-1199
                </h3>
                    <p className='chineseParagraph p-2'>
                      岡波巴最主要的弟子當中有一位名叫達瑪旺秋，被視為巴融傳承的第一位祖師，尊者於公元
                      1127 年出生於西藏澎域雍瓦地方 ('Phan yul yung ba) 的占迦 (Bran
                      ka) 家族，父名乃丹頓巴 (Gnas brtan ston pa)，母名洛窮瑪
                      (Lochung
                      ma)。從幼年開始，除了修持佛陀的神聖教法之外，對其他事情都不感興趣，唯一的目標就是找尋最好的老師並隨之學習。七歲時於堪布噶哇巴和旺丘雄惹二位大師的坐下出家。十歲開始又從格西甲域瓦及格西噶瓦等大師處學習慈氏五論，以及《集學論》、《入菩薩行論》、《律經》等佛法精意。有一次在夢境中空行母跟他講：“你的上師在達波山，他是無比殊勝的化身，你應該追隨他。”後來達瑪旺秋遇到一位瑜伽士，並問他要往哪裏去，“我正要到達波山去，殊勝的岡波巴就住在哪裏。”“帶我一起去，我也想見他”，於是在這年（1147）年，達瑪旺秋見到了岡波巴，並成為一位在在身、語、意上全然師事上師的傑出弟子的典範，他甚至還救了崗波巴好幾次，由於達瑪旺秋對上師圓滿的信心，在一次灌頂後岡波巴對達瑪旺秋講到：“在灌頂過程中我們師徒二人來比較的話，你的障礙消除的比我還要更多。大師傳授予他大手印即身成佛之大密法和其它噶舉派沒有的一些密法和教悔。
                      為教化眾生及宏揚佛法，受岡波巴大師之授記，去往北方神聖的崗薩山開始精進不懈的修持，完全放棄了對食物、衣著、名聲的追求，崗薩山神為他帶來了生活必需品，他在這裏呆了十三年之久，證得大手印的成就。在閉關末期他已經能夠飛越天空，穿越岩石，具有大成就者的征兆，期間曾收眾多非人為弟子，當時諸多聖師、十萬空行母及護法神均顯現於聖地祝賀，公元
                      1160
                      年尊者在崗薩山附近的聖地巴融興建了巴融寺（成為上道場），並在此停留了好幾年，愈來愈多信仰虔誠的民眾帶著供養品來到這裏，有些甚至從中國遠道而來。然而一場山崩將他的寺院掩埋，於是他接受東藏囊謙國王的邀請在那裏建立了第二個寺院，於此地教化眾生、興盛教法，畢生奉獻於利益眾生和弘揚佛法之事業。七十三歲時，於藏曆氐宿
                      (四月)
                      初二日晚半夜時分，示現涅槃。當時看見一股紅光環繞天空，花雨降落，樂聲響亮，特別是響起宏亮的鼓音，地震。初十日火化遺體，煙飄向正前方天空中密布，一會兒變成彩色虹傘，在天空顯現彩虹、蓮花、樹木、勝幢和旗幡等相狀。他有許多弟子，其中兩位心傳弟子是：侄子嘉瓦劄巴
                      (Rgyal ba grags pa)、侄子喜饒旺秋 (Shes
                      rrabbangjiu)。而殊勝弟子則是：帝師瑞巴謝惹桑波
                      （Dihxireupa）。因影響巨大而弟子眾多之故，於是形成了一個新的教派，其因起源於巴融寺，故世人尊稱為巴融噶舉。
                </p>
                  </Col>
                </Row>
                {/* Second intro */}
                <Row>
                  <Col>
                    <h3 className='text-left text-secondary chinese mb-3 '>
                      帝師瑞巴 1164-1236
                </h3>
                    <p className='chineseParagraph p-2'>
                      1198
                      年達瑪旺秋尊者圓寂，作為其心傳之弟子帝師瑞巴將巴融噶舉進一步發揚光大，為巴融噶舉的發展做出了巨大的貢獻。他還設計了一種具有五個尖頂的帽子，以紀念他的五位上師：巴融巴、止貢巴、香仁波切、桑結葉巴、達瓏巴。帝師瑞巴生於藏北牧區巴察地區四大雪欽（部落）之一的達雪那爾摩地方，出生後，一位本教法師蔔算預言：「他將成為受人尊敬者，若是進入佛法，他將成為高僧。」父母為他取名為霍爾劄
                      。十三歲，獲悉上師寶巴融巴達瑪旺秋的盛名，渴望見面，甚至激動得全身毛發抖動。當時巴融巴住在絳孜瓦爾
                      領袖的城堡，被他父親請到部落，恭敬承事，供獻良馬鞍雕和綾絹等財物。後來，巴融巴達瑪旺秋去了多康，帝師瑞巴沒有隨行。
                      十五歲那年，在蔡巴拜見了香仁波切（
                      1123-1193)。遇到戰爭，指揮官要求他參加戰鬥。因此，他參加戰爭運送石頭，投射沙石，最後取得勝利。香仁波切說：「無論我怎樣做，也離不了大手印。」帝師瑞巴受其加持，得見心性。
                      在葉巴謁見桑傑貢巴時，請求賜名，命名爲謝惹桑波 (慧獅)。
                      前去達隆，拜見了達隆塘巴
                      (1142—1210)，聽講大手印多哈，得到了帕木竹巴的全集。回到家鄉後，靜心溫習和分析所學教授。十八歲時，聽到止貢仁波切
                      (1143-1217)
                      在納木拉的拉瑪岩洞傳法，立即前去拜見，得到止貢仁波切悲湣攝受，傳授了五支大印教授，及勝樂、金剛亥母灌頂等。二十五歲，桑傑貢巴邀請巴融巴達瑪旺秋到耶巴安窮地方，帝師瑞巴隨行。猴年四月十五日，從上師巴融巴達瑪旺秋、桑傑貢巴、劄茹巴頓巴紮、阿闍黎塔協達瑪循努等受沙彌戒。三十二歲時，從軌範師塔瑪貝、親教師古拉哇
                      、屏教師達循等二十位比丘僧受近圓戒，並從軌範師塔瑪貝聽講《別解脫戒經》、《律經廣釋》及《集學論》，駐錫止貢寺一年。帝師瑞巴的「帝師」頭銜來自西夏，他事實上是西夏王朝的最後一任帝師。1200
                      年，當他三十七歲時，他來到西夏境內的甘州，遇到格西藏波巴,
                      他是杜松欽巴的弟子)，這位人士即是帝師瑞巴就任西夏帝師的前任帝師。由於阿闍黎雅隆巴的引介，他在甘州見到了西夏國王，並受邀來到西夏首府－Irgai
                      (藏文中稱為 mgar)。 帝師瑞巴受封為國師；成吉斯汗的蒙古軍隊於
                      1209 年首次包圍西夏首府， 自言：「我、師利普巴
                      (他是止貢巴吉天送恭的弟子)、藏波巴修持『遮止軍隊』的儀軌。蒙軍欲放水淹西夏城，但大水卻回淹蒙軍，蒙軍遂退。1217
                      年，帝師瑞巴至臨洮持了前任帝師藏波巴的喪禮。1219
                      年回到首府，在為國王灌頂後，國王贈與他「帝師」的頭銜，他解釋說唯有替國王灌頂者方受「帝師」之名。蒙古軍隊第二度回來，帝師瑞巴修法後，蒙古將軍過世，蒙軍遂退；蒙古軍隊第三次回來，帝師瑞巴修持『遮止軍隊』儀軌，蒙軍複退。
                      帝師瑞巴在一次淨觀中體會到西夏的滅亡乃是由於過去業力的關系，不是他個人的修持所能扭轉的。在知曉蒙古軍隊將第四度回來後，他就率領弟子離開西夏，返回康區；他前後一共在西夏待了二十七年。成吉斯汗於
                      1227 年攻下西夏。1228
                      年十月，耳聞蒙軍將進攻康區，他就率領弟子逃往藏北地區；1229
                      年三月，終於返回巴融寺。在此期間，他也條停止貢與達瓏兩地之間的紛爭。他的晚年生活主要以在康區的宗教活動為主，建立了固本寺等許多寺院
                      。1236年帝師瑞巴在囊謙附近圓寂,在他的遺體被運回囊謙的路上，由於大雨河水暴漲而堵住了去路，這時河水自然從中分離讓出路來讓運送隊伍通過。於
                      1236 年圓寂於囊謙。
                </p>
                  </Col>
                </Row>
                {/* third intro */}
                <Row>
                  <Col>
                    {/* Title */}
                    <h3 className='text-left text-secondary chinese mb-3 '>
                      瑞巴卡波 1198-1272
                </h3>
                    <p className='chineseParagraph p-2'>
                      敬安• 瑞巴卡波於 1198
                      年生於西夏首府，他是帝師瑞巴在西夏所收的弟子。自幼喜愛佛法，不好世俗事。稍長，由宿願緣故，一聽到衆生怙主帝師瑞巴之名，就産生殊勝敬仰。一次，他帶著大量禮品獻給帝師，上師發現他根器良好，遂收為弟子。從此，他隨侍上師左右，並在僧衆中受出家戒和近圓戒，取名喜饒絳曲(慧菩提)，專心聽講內外諸法。尤其修習那若六法，打通氣脈，容貌猶如滿月般明亮，因此又名
                      (白衣者)，名聲遠播。一次，他從覺達山口向上走，仿佛十五的月亮自山口升起，顯得非常威嚴，許多人都看見了他散發出的萬丈光芒。這位大師的偉大之處不可思議，甚至超越了帝師·瑞巴的成就。
                      帝師·瑞巴圓寂之後，瑞巴卡波駐錫固本寺，僅用五十天就完成上師仁波切靈塔。1237
                      年在住地建設寢室和寺院，稱爲「固本雜瓦」。
                      由於他在修持上的卓越成就與威望，得到元世祖忽必烈的護持來修建固本寺經堂，並供養六地萬戶爲其管轄範圍，
                      瑞巴卡波從西夏召來木匠和石匠，新建佛殿、私邸，面積一百二十柱，共三層。他還在邁欽頂建立修院，臥室和法座至今仍在。由於缺水，他從山頂引出了水，供寺院使用。
                      他將皇帝供養的巨額財富興建了許多廟宇，他特別在囊謙新建了一座規模宏偉的寺廟，裏面擁有難以計數的佛像，其中主要的一尊，就是拉薩覺沃佛像的複制品。最後他也被皇帝尊為相當於帝師瑞巴的精神領袖。。
                      尊者於六十五歲的藏曆水狗年五月十八日時圓寂。
                </p>
                  </Col>
                </Row>
                {/* forth intro */}
                <Row>
                  <Col>
                    {/* Title */}
                    <h3 className='text-left text-secondary chinese mb-3 '>
                      慮美多傑 1227-1292
                </h3>
                    <p className='chineseParagraph p-2'>
                      慮美多傑生於在多康六地之一的上部止隆地區。由於宿緣傾心佛法，比較容易地掌握了藏文讀寫。一次，爲建六地萬戶的修行殿，而來到固本寺，油然生起敬仰之心，不顧身命地努力修建佛殿，因而清除了惡障。佛殿落成時，瑞巴卡波騎馬來到楚康囊爲參加建寺的六地工人講法。瑞巴卡波臨走時，發現慮美多傑是一位有緣分的人，能夠肩負利益衆生的重擔。於是，問他：「你在這裏出家，能否修行佛法?」無體金剛頓時興奮不抑，淚流滿面的說：「我無論如何將隨侍上師，請收容。」瑞巴卡波也格外高興從此，無身金剛離開親戚鄰舍獨居修行。不久，從瑞巴卡波等受出家戒，取名絳曲貝
                      (菩提祥)，聽講戒律及其它法門。求得勝樂、喜金剛、摩訶摩衍等灌頂，取秘號彌覺多傑
                      (不動金剛)。聞習完全部教授次第法後，絳曲貝專心修煉大手印法，體悟心境一體，獲得大神通。他在此興建了一座名為囊索·謙摩的寺院，囊謙就是因這座寺院而得名有一百五十根柱子支撐的囊索·謙摩寺顯得龐大壯觀。寺院開光慶典期間受功德主之邀，師徒十八人前往應供時，慮美多傑在眾人面前享用了一鍋又一鍋的卓瑪（一種浸泡在提煉過的牛油裏，非常油膩的根莖類甜點），於是謠言四起，大家都擔心他將會死掉，不死也會病的很重。，上師瑞巴卡波說：「（慮美多傑）有很好的氣脈明點修持，應該不會有事，不然妳們去看看怎樣了。」於是大家前往查看時，發現其坐在一處岩石上，擺出瑜珈姿態修氣脈明點時，之前吃下的酥油皆從身體的毛孔中排放出，讓自己比以前更加光芒四射。他白天散發日光，夜晚散發月光和油燈光，行向何處都沒有身影，故人稱「慮美」(無身)。上師圓寂後，他爲上師舉行了忌日法會，前往前藏從歐色傑紮巴學習喜金剛、本尊都索瑪，以及戒律；在蔡貢塘從拉浦尼瑪沃聞習《五釘》等蔡巴教法；從恰域寺僧人學習經論。那時，薩迦派喇嘛八思巴
                      (1235-1280)
                      從蒙古進藏途經多麥，固本寺的全體老僧前去拜見，敬獻禮物，請求八思巴說：「上師的化身已去佛國，現在您是西藏全體人民的主人，請爲我們上師的寺院委任一名上師。」八思巴說：「我們教派不同，如果委派我宗喇嘛不合適，委任你自己的弟子中較有影響的一位作上師，這樣符合我的做法。」老僧們說：「有一位上師的心傳弟子慮美多傑，現在他住在衛藏。」八思巴說：「如果這樣，派人去把他叫到我跟前來。」慮美多傑駐錫蔡貢塘寺時，八思巴從薩迦寺派差使來，要他去擔任固本寺上師並為他升座，授予他（拉纖）的地位，成為十三位皇族教師之一。當他到達康區時，受到固本雜哇寺全體僧人和六地僧俗部衆的隆重迎接，從此，他更加學習三戒和三學，努力鑽研顯密教法，利用一切時間修煉，智慧達到圓滿。慮美多傑讓佛法興盛於整個囊謙，並用他的靈性影響力讓整個王國以禪修者之鄉著稱。水龍年
                      (1292)
                      二月初八日示現涅盤相，享年六十六歲。遺體火化之日，天空彩虹密布，花雨飄落，火化後遺骨上出現十三顆右旋螺舍利等，連續七晝夜天降舍利雨。而慮美多傑有眾多弟子當中，最重要的有四位，分別是蔣確修努
                      、絳曲滾波、拉巴次程僧格、釋迦多傑。
                </p>
                  </Col>
                </Row>

                {/* fifth intro */}
                <Row>
                  <Col>
                    {/* Title */}
                    <h3 className='text-left text-secondary chinese mb-3 '>
                      蔣確修努
                </h3>
                    <p className='chineseParagraph p-2'>
                      蔣確修努是慮美多傑的侄輩，也是他的弟子。慮美多傑圓寂之後，大家選
                      出蔣確修努作為法座繼承人當使者找到他時告訴他：“您必須離開您隱修的地方回去當國王，在佛法的黃金寶座上，您還是可以繼續進行靈修”。繼任法座之後，蔣確修努受中國皇帝冊封崇高的宗教地位。他用王室的供養在囊謙興建了一座寺院名為倉芒薩寺，倉薩之名由此而來。後來倉薩家族一直是巴榮噶舉教法的傳承持有者，迄今為止已延續至第十三代。
                </p>
                  </Col>
                </Row>
              </>
            ) : (
                // Tibetan Section
                <>
                  <Row className='kyaguContent d-flex align-items-center justify-content-center'>
                    <Col className='align-items-center'>
                      {/* Header Image */}
                      {/* Title */}
                      <h3 className='text-left text-secondary tibetan_Dutsa mb-3'>
                        བཀའ་བརྒྱུད།
                    </h3>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Tab.Container id='left-tabs' defaultActiveKey='0'>
                        <Row>
                          <Col sm={5} md={3}>
                            <Nav variant='pills' className='flex-column '>
                              {/* Tabs */}
                              {
                                tabList.map((tabItem, index) => {
                                  return (
                                    <Nav.Item className='navItem' key='id'>
                                      <Nav.Link eventKey={index}>
                                        <h4>{tabItem.title}</h4>
                                      </Nav.Link>
                                    </Nav.Item>)
                                })
                              }

                            </Nav>
                          </Col>

                          {/* Content */}
                          <Col sm={7} md={9}>
                            <Tab.Content className='tabContent'>
                              <Tab.Pane eventKey='1' className='tabPane'>

                                <p>
                                  <h1>བོད་ཡིག་</h1>
                                </p>
                              </Tab.Pane>
                              <Tab.Pane eventKey='second' className='tabPane'>
                                <p>i am Singapore</p>
                              </Tab.Pane>
                              <Tab.Pane eventKey='third' className='tabPane'>
                                <p>i am tibet</p>
                              </Tab.Pane>
                              <Tab.Pane eventKey='forth' className='tabPane'>
                                <p>i am tibet</p>
                              </Tab.Pane>
                            </Tab.Content>
                          </Col>
                        </Row>
                      </Tab.Container>
                    </Col>
                  </Row>
                </>
              )
          }

        </div>
      </Container>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    lang: state.lang.lang,
  };
};

export default connect(mapStateToProps)(Kyagu);
